"use strict"

import { FormField } from '@/lib/core/components/data/form/FormField'

export class FieldText extends FormField {
  constructor({ register, fields, name }) {
    super({ register, fields, name })
  }
}